// src/components/suppliers/Table/SuppliersTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Avatar, Chip, Box, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const SuppliersTableRow = ({
    supplier,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false
}) => {
    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(supplier?.id);
    const imageUrl = supplier?.image?.url || supplier?.image?.preview || null;

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, supplier?.id)}
                    inputProps={{ "aria-labelledby": `supplier-${supplier?.id}` }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, supplier);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell>{serial}</TableCell>

            <TableCell>
                <Avatar
                    src={imageUrl}
                    alt={supplier?.name?.en || "Supplier"}
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 1,
                        bgcolor: isDark ? "rgba(16,185,129,0.2)" : "rgba(16,185,129,0.1)",
                    }}
                >
                    {!imageUrl && <BusinessIcon />}
                </Avatar>
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {supplier?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {supplier?.name?.en || "-"}
            </TableCell>

            <TableCell>
                {supplier?.phone ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <PhoneIcon sx={{ fontSize: 16, color: isDark ? "#9CA3AF" : "#6B7280" }} />
                        <Typography variant="body2" sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                            {supplier.phone}
                        </Typography>
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary">-</Typography>
                )}
            </TableCell>

            <TableCell>
                {supplier?.email ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <EmailIcon sx={{ fontSize: 16, color: isDark ? "#9CA3AF" : "#6B7280" }} />
                        <Typography
                            variant="body2"
                            sx={{
                                color: isDark ? "#E5E7EB" : "#1F2937",
                                maxWidth: 200,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {supplier.email}
                        </Typography>
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary">-</Typography>
                )}
            </TableCell>

            <TableCell>
                <Chip
                    label={supplier?.services_count || 0}
                    color="primary"
                    size="small"
                    variant="outlined"
                    sx={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        minWidth: 50,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, supplier);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default SuppliersTableRow;
